import React, { useState } from "react";
import "./style.css";
import { useMediaQuery } from "react-responsive";
import DesktopMakeModelYear from "../DesktopMakeModelYear";
import MobileMakeModelYear from "../MobileMakeModelYear";
import useMakeModelYear from "../../hooks/MakeModelYearHook";
import { cloneDeep } from "lodash";

const MakeModelYear = ({ showHeader }) => {
  const {
    yearOptions,
    makeOptions,
    modelOptions,
    variantOptions,
    loading,
    userInput,
    setUserInput,
    clearModelOptions,
    clearVariantOptions,
    clearYearOptions,
  } = useMakeModelYear();

  const submit = (e) => {
    e.preventDefault();

    const queryParameters = new URLSearchParams();
    if (!!userInput.make) {
      queryParameters.append("make", userInput.make);
    }
    if (!!userInput.model) {
      queryParameters.append("model", userInput.model);
    }
    if (!!userInput.variant) {
      queryParameters.append("variant", userInput.variant);
    }
    if (!!userInput.year) {
      queryParameters.append("year", userInput.year);
    }

    window.location.href = `/products/all?${queryParameters.toString()}`;
  };

  const handleUserVehicleChange = (name) => (event, newValue) => {
    let userInputCopy = cloneDeep(userInput);
    userInputCopy[name] = newValue;

    if (name === "make") {
      userInputCopy.model = null;
      userInputCopy.variant = null;
      userInputCopy.year = null;
      clearModelOptions();
      clearVariantOptions();
      clearYearOptions();
    } else if (name === "model") {
      userInputCopy.variant = null;
      userInputCopy.year = null;
      clearVariantOptions();
      clearYearOptions();
    } else if (name === "variant") {
      userInputCopy.year = null;
      clearYearOptions();
    }
    setUserInput(userInputCopy);
  };

  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  return (
    <>
      {isMobile === true && (
        <MobileMakeModelYear
          yearOptions={yearOptions}
          makeOptions={makeOptions}
          modelOptions={modelOptions}
          variantOptions={variantOptions}
          loading={loading}
          userInput={userInput}
          setUserInput={setUserInput}
          submit={submit}
          handleUserVehicleChange={handleUserVehicleChange}
          showHeader={showHeader}
        />
      )}
      {isMobile === false && (
        <DesktopMakeModelYear
          yearOptions={yearOptions}
          makeOptions={makeOptions}
          modelOptions={modelOptions}
          variantOptions={variantOptions}
          loading={loading}
          userInput={userInput}
          setUserInput={setUserInput}
          submit={submit}
          handleUserVehicleChange={handleUserVehicleChange}
          showHeader={showHeader}
        />
      )}
    </>
  );
};

export default MakeModelYear;
